// ** React Imports
import { useMemo } from "react";
import { useParams } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Custom Filters
import useFilterSex from "hooks/filters/useFilterSex";
import { compute as filterPeriodCompute } from "hooks/filters/useFilterPeriod";

// #####################################################

const useRankingsApiParams = () => {
	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	// ** Odczytanie parametrów z adresu URL
	const {
		rankingPeriod: filterPeriodParam = "today",
		country: filterCountryParam = null,
		region: filterRegionParam = null,
		sex: filterSexParam = null,
	} = useParams();

	// **
	const userPrefferedSex = useSelector(
		(state) => state.globalUser.searchSex
	).join("-");

	const userUrlSearch = useSelector((state) => state.globalUser.urlSearch);
	const userUrlSearchCountry = userUrlSearch
		? userUrlSearch.split("/")[0]
		: null;

	// **
	const initialFilterSex = useMemo(() => {
		if (filterSexParam) {
			return filterSexParam;
		} else if (userPrefferedSex === "" || !isAuth) {
			return ""; //"woman-man-couple-transsexual";
		} else if (userPrefferedSex) {
			return userPrefferedSex;
		}
		return ""; //"woman-man-couple-transsexual";
	}, [filterSexParam, userPrefferedSex, isAuth]);

	// **
	const filterSex = useFilterSex({
		initial: initialFilterSex,
		multiple: true,
	});

	const getApiParams = () => {
		return {
			period: filterPeriodCompute.urlToApiParam(filterPeriodParam),
			country: filterCountryParam || userUrlSearchCountry,
			region: filterRegionParam,
			sex: filterSexParam
				? filterSex.compute.urlToApiParam(filterSexParam)
				: filterSex.compute.urlToApiParam(
						isAuth ? userPrefferedSex : "any"
				  ),
			page: 1,
		};
	};
	// #####################################################

	return { getApiParams };
};

// #####################################################

export default useRankingsApiParams;

// #####################################################
